import {pinGrowth} from './map-geometry.mjs';
import {collidingBadges} from './map-badges.mjs';
import {preparePinProperties,registerPinSprites,pinPixelRatio} from './pins.mjs';
import {prepareHitSprites} from './hits.mjs';
import {setSiteData,applySiteDiff,clearSiteData} from './site-data.mjs';

// Canvas sprite preparation and collision geometry are rendering-only and only
// visit near pins (or the at most 25 ranked results), never the nationwide dots.
export function mapRenderer(map,state){
  const hiddenBadges=new Set();
  const apply=async d=>{
    const {ready,prefs,profile,detailId,selection}=state();
    if(!ready)return;
    if(d.gpu)map._w2cGpu?.apply(d.gpu);
    else if(d.data)await map.getSource('sites').setData(d.data);
    else if(d.diff)await applySiteDiff(map.getSource('sites'),d.diff);
    if(d.pins){
      const features=d.pins,resolution=pinPixelRatio(map.isZooming?.()?1:pinGrowth(map.getZoom()));
      preparePinProperties(features,prefs.theme,prefs.secondary,profile,null,resolution);
      collidingBadges(features,map,detailId,selection?.scale?.());hiddenBadges.clear();
      for(const f of features)if(f.properties.hideBadge)hiddenBadges.add(f.properties.id);
      preparePinProperties(features.filter(f=>f.properties.hideBadge),prefs.theme,prefs.secondary,profile,null,resolution);
      registerPinSprites(map,features,profile);
      prepareHitSprites(map,features,prefs.theme,profile);selection?.refresh();
      await setSiteData(map.getSource('site-pins'),features);
    }
  };
  return {apply,hiddenBadges,clear:()=>{for(const id of ['sites','site-pins']){const source=map.getSource(id);if(source)clearSiteData(source);}}};
}
